import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

const PublicSite = lazy(() => import('./pages/PublicSite'));
const AdminLogin = lazy(() => import('./pages/AdminLogin'));
const AdminDashboard = lazy(() => import('./pages/AdminDashboard'));
const LegalPages = lazy(() => import('./pages/LegalPages'));

const Loader = () => (
  <div className="min-h-screen flex items-center justify-center bg-bg1">
    <div className="text-gold text-sm tracking-[0.3em] uppercase">Loading…</div>
  </div>
);

const Privacy = () => import('./pages/LegalPages').then(m => ({ default: m.PrivacyPage }));
const Cookies = () => import('./pages/LegalPages').then(m => ({ default: m.CookiesPage }));
const Terms   = () => import('./pages/LegalPages').then(m => ({ default: m.TermsPage }));
const LazyPrivacy = lazy(Privacy);
const LazyCookies = lazy(Cookies);
const LazyTerms   = lazy(Terms);

// When the bundle is packaged for the WordPress marketing theme, admin routes
// are stripped at build time via REACT_APP_DISABLE_ADMIN=1. Dev/preview keep them.
const ADMIN_DISABLED = process.env.REACT_APP_DISABLE_ADMIN === '1';

// Subdirectory WordPress installs (e.g. /eureka-staging) need a basename so
// react-router resolves <Link to="/services"> against the WP install root,
// not the domain root. Injected at runtime by the WP theme.
const ROUTER_BASENAME = (typeof window !== 'undefined' && window.EurekaConfig && window.EurekaConfig.basename) || '';

export default function App() {
  return (
    <BrowserRouter basename={ROUTER_BASENAME}>
      <Suspense fallback={<Loader/>}>
        <Routes>
          {!ADMIN_DISABLED && <Route path="/admin/login" element={<AdminLogin/>}/>}
          {!ADMIN_DISABLED && <Route path="/admin/*" element={<AdminDashboard/>}/>}
          <Route path="/privacy" element={<LazyPrivacy/>}/>
          <Route path="/cookies" element={<LazyCookies/>}/>
          <Route path="/terms" element={<LazyTerms/>}/>
          <Route path="*" element={<PublicSite/>}/>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
